import { LocalTrack, Logger, Room, connect } from 'twilio-video'

import ErrorBoundary from '../../../containers/error_boundary'
import { updateParticipant } from '../../../reduxes/slices/calls/actions'
import { getConnectionOptions } from './web_rtc_config'

const logger = Logger.getLogger('twilio-video')
logger.setLevel('error')

const originalFactory = logger.methodFactory
logger.methodFactory = function (
  methodName: any,
  logLevel: any,
  loggerName: any,
) {
  const method = originalFactory(methodName, logLevel, loggerName)

  return function (
    datetime: any,
    logLevel: any,
    component: any,
    message: any,
    data: any,
  ) {
    method(datetime, logLevel, component, message, data)

    const error = new Error(
      JSON.stringify({
        message,
        data,
      }),
    )
    ErrorBoundary.logErrorToMyService(error)
  }
}

/* eslint-disable @typescript-eslint/no-explicit-any */
export const joinRoom = (
  dispatch: any,
  axios: any,
  accessToken: string,
  call: any,
  memberId: number,
  tracks: LocalTrack[],
) => {
  const connectOptions = getConnectionOptions()
  // eslint-disable-next-line
  // @ts-ignore
  return connect(accessToken, {
    name: call.room_sid,
    tracks,
    ...connectOptions,
  }).then((room: Room) => {
    dispatch(
      axios(
        updateParticipant(memberId, call.topic_id, {
          isConnectedToRoom: true,
        } as any),
      ),
    )
    return Promise.resolve({ room })
  })
}
